import _ from "lodash";

import { float6Normalizer } from "validators";

export const treeTierMapper = (FORM_NAME, dispatch, change, feeTemplate) => {
	const findTreeTierMapperFormValue = _.filter(
		feeTemplate.fieldBlocks,
		item => item.name === "ThreeTier",
	);

	if (_.isEmpty(findTreeTierMapperFormValue)) return;

	const findThreeTierAuthorizationFeeValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierAuthorizationFee",
		},
	);

	const findThreeTierSalesTransactionFeeValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierSalesTransactionFee",
		},
	);

	const findThreeTierQualVMCDValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierQualVMCD",
		},
	);

	const findThreeTierQualAmexValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierQualAmex",
		},
	);

	const findThreeTierQualOfflineDebitValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierQualOfflineDebit",
		},
	);

	const findThreeTierMidQualVMCDValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierMidQualVMCD",
		},
	);

	const findThreeTierMidQualAmexValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierMidQualAmex",
		},
	);

	const findThreeTierMidQualOfflineDebitValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierMidQualOfflineDebit",
		},
	);

	const findThreeTierNonQualVMCDValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierNonQualVMCD",
		},
	);

	const findThreeTierNonQualAmexValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierNonQualAmex",
		},
	);

	const findThreeTierNonQualOfflineDebitValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "threeTierNonQualOfflineDebit",
		},
	);

	const findPassCardBrandFeesValue = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "passCardBrandFees",
		},
	);

	const findIsPassThroughInterchange = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "isPassThroughInterchange",
		},
	);

	const findInterchangePlusRevenueType = _.find(
		findTreeTierMapperFormValue[0].fields,
		{
			name: "interchangePlusRevenueType",
		},
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierAuthorizationFee",
			float6Normalizer(findThreeTierAuthorizationFeeValue?.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierSalesTransactionFee",
			float6Normalizer(findThreeTierSalesTransactionFeeValue?.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierQualVMCD",
			float6Normalizer(findThreeTierQualVMCDValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierQualAmex",
			float6Normalizer(findThreeTierQualAmexValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierQualOfflineDebit",
			float6Normalizer(findThreeTierQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierMidQualVMCD",
			float6Normalizer(findThreeTierMidQualVMCDValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierMidQualAmex",
			float6Normalizer(findThreeTierMidQualAmexValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierMidQualOfflineDebit",
			float6Normalizer(findThreeTierMidQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierNonQualVMCD",
			float6Normalizer(findThreeTierNonQualVMCDValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierNonQualAmex",
			float6Normalizer(findThreeTierNonQualAmexValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"threeTierNonQualOfflineDebit",
			float6Normalizer(findThreeTierNonQualOfflineDebitValue.value),
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"passCardBrandFees",
			findPassCardBrandFeesValue.value,
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"isPassThroughInterchange",
			findIsPassThroughInterchange?.value,
		),
	);

	dispatch(
		change(
			FORM_NAME,
			"interchangePlusRevenueType",
			findInterchangePlusRevenueType?.value,
		),
	);
};
